import { render } from "./HeaderShopping.vue?vue&type=template&id=5d027b71"
import script from "./HeaderShopping.vue?vue&type=script&lang=js"
export * from "./HeaderShopping.vue?vue&type=script&lang=js"

import "./HeaderShopping.vue?vue&type=style&index=0&id=5d027b71&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__